import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const ButtonComponent = ({ last, link, text }) => {
  const Button = styled(Link)`
    align-items: center;
    background-color: #ffffffdd;
    border: none;
    border-radius: 10pt;
    box-shadow: #0000001a 0pt 3pt 6pt;
    color: #6f6f6f !important;
    display: flex;
    font-family: 'museo-sans', sans-serif;
    font-size: 1.33rem !important;
    font-weight: 600;
    height: 55pt;
    justify-content: center;
    margin: auto;
    margin-bottom: ${last ? `0` : `19pt`};
    opacity: 80%;
    text-decoration: none;
    width: 80vw;

    &:hover {
      box-shadow: #00000033 0pt 3pt 6pt;
      opacity: 100%;
    }

    @media screen and (min-width: 768px) {
      width: 240pt;
    }
  `
  return <Button to={link}>{text}</Button>
}

export default ButtonComponent
